<template>
  <el-dialog
    title="调整库存"
    :visible.sync="adjustQuantityVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form label-width="110px">
      <el-form-item
        label="报价类型"
        required
      >
        {{ detailData.priceType | keyFilter('myStore','priceType') }}
      </el-form-item>
      <el-form-item
        label="调整剩余库存"
        required
      >
        <el-input-number
          v-model.trim="detailData.remainQuantity"
          class="w220"
          :controls="false"
        />
      </el-form-item>
    </el-form>
    <div class="m-t-30 m-b-10 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
export default {
  name: 'AdjustQuantity',
  components: {
  },
  props: {
    adjustQuantityVisible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => { return {} }
    },
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    toSubmit () {
      if (Number(this.detailData.remainQuantity) < 0) {
        this.$message.warning('调整剩余库存不能小于0')
        return
      }
      const param = {
        id: this.detailData.id,
        remainQuantity: this.detailData.remainQuantity
      }
      // 区分调整库存和发布挂牌
      api.myStore.adjustQuantity(param).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
        this.$emit('refresh')
      })
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.warehouse {
  max-height: 500px;
  overflow-y: auto;
}
</style>
